import React from 'react';
const tomes = [{
  emoji: '🔵',
  title: 'Primeras Letras',
  desc: 'Trazado, abecedario y pre-escritura'
}, {
  emoji: '🟢',
  title: 'Mundo Numérico',
  desc: 'Números, conteo y lógica inicial'
}, {
  emoji: '🟠',
  title: 'Manitos Creativas',
  desc: 'Tijera, laberintos y motricidad'
}, {
  emoji: '🟣',
  title: 'Mis Emociones',
  desc: 'Empatía, calma y reconocimiento'
}, {
  emoji: '🟡',
  title: 'Rutinas del Hogar',
  desc: 'Autonomía, orden y hábitos'
}, {
  emoji: '⭐',
  title: 'Inglés Divertido',
  desc: 'Vocabulario básico en inglés'
}];
const includes = ['+500 páginas imprimibles', 'Por nivel de dificultad', 'Niños de 2 a 7 años', 'Ilustraciones profesionales', 'Sin materiales especiales', 'Cualquier impresora', 'Formato A4 optimizado', 'Contexto educativo argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-8 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-333">
      <div className="mx-auto max-w-3xl" data-id="element-334">
        {/* TÍTULO */}
        <p className="text-center text-xs font-bold tracking-[2px] uppercase text-orange-500 mb-1" data-id="element-335">
          📦 Todo lo que recibís
        </p>
        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-336">
          Lo que <span className="text-orange-500" data-id="element-337">incluye</span> tu Megapack
        </h2>
        <p className="text-center text-xs text-gray-500 mb-5 max-w-md mx-auto" data-id="element-338">
          Todo ordenado, diseñado y listo para imprimir hoy.
        </p>

        {/* LOS 6 TOMOS */}
        <div className="bg-white border border-orange-200 rounded-xl p-4 shadow-sm mb-5" data-id="element-339">
          <h3 className="text-sm font-black text-orange-500 m-0 mb-3" data-id="element-340">
            📚 LOS 6 TOMOS · 2 a 7 años
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-id="element-341">
            {tomes.map(tome => <div key={tome.title} className="flex items-center gap-2 bg-orange-50 border border-orange-100 rounded-lg px-3 py-2" data-id="element-342">
                <span className="text-base shrink-0" data-id="element-343">{tome.emoji}</span>
                <div className="min-w-0" data-id="element-344">
                  <span className="block text-xs font-bold text-gray-900 truncate" data-id="element-345">
                    {tome.title}
                  </span>
                  <span className="block text-[10px] text-gray-500 leading-tight truncate" data-id="element-346">
                    {tome.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* CADA TOMO INCLUYE */}
        <div className="bg-orange-50 border border-orange-200 rounded-xl px-4 py-3 mb-5" data-id="element-347">
          <h3 className="text-sm font-black text-orange-500 m-0 mb-2 text-center" data-id="element-348">
            ✅ Cada tomo incluye:
          </h3>
          <div className="flex flex-wrap justify-center gap-1.5" data-id="element-349">
            {includes.map(item => <span key={item} className="bg-white border border-orange-100 rounded-full px-3 py-1 text-[11px] font-medium text-gray-700" data-id="element-350">
                {item}
              </span>)}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-351">
          
          
        </div>
      </div>
    </section>;
}